export default class DateHelper {
    static UnixToLocal = (date) => {
        return new Date(date * 1000);
    }
}